var _path, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0002 36.6666H30.0002C33.6821 36.6666 36.6668 33.6819 36.6668 30V16.4544H3.3335V30C3.3335 33.6819 6.31826 36.6666 10.0002 36.6666Z",
    fill: "#0E308E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3335 4.58334C16.2624 4.58334 14.5835 6.26228 14.5835 8.33334V10C14.5835 10.6904 14.0239 11.25 13.3335 11.25C12.6431 11.25 12.0835 10.6904 12.0835 10V8.33334C12.0835 4.88156 14.8817 2.08334 18.3335 2.08334H21.6668C25.1186 2.08334 27.9168 4.88156 27.9168 8.33334V10C27.9168 10.6904 27.3572 11.25 26.6668 11.25C25.9765 11.25 25.4168 10.6904 25.4168 10V8.33334C25.4168 6.26228 23.7379 4.58334 21.6668 4.58334H18.3335Z",
    fill: "#0E308E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 10H10.0002C6.31826 10 3.3335 12.9848 3.3335 16.6667V21.6667H10.1756C10.4485 21.6667 10.6697 21.4455 10.6697 21.1726C10.6697 19.7919 11.789 18.6726 13.1697 18.6726C14.5504 18.6726 15.6697 19.7919 15.6697 21.1726C15.6697 21.4455 15.8909 21.6667 16.1638 21.6667H23.8465C24.1194 21.6667 24.3406 21.4455 24.3406 21.1726C24.3406 19.7919 25.4599 18.6726 26.8406 18.6726C28.2213 18.6726 29.3406 19.7919 29.3406 21.1726C29.3406 21.4455 29.5618 21.6667 29.8347 21.6667H36.6668V16.6667C36.6668 12.9848 33.6821 10 30.0002 10Z",
    fill: "#0E308E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.6016,
    y: 20,
    width: 2.5,
    height: 4.65671,
    rx: 1.25,
    fill: "#0E308E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9346,
    y: 20,
    width: 2.5,
    height: 4.65671,
    rx: 1.25,
    fill: "#0E308E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.9bb2405d2528694471b634a69e46bf4c.svg";
export { ForwardRef as ReactComponent };